module.exports = __webpack_public_path__ + "img/arrow_forward.911f7205.svg";